import { Box, Typography } from "@mui/material"
import { UploadFileOutlined, VisibilityOffOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React, { useState } from "react"

import CompanyFilesTable from "../../tables/CompanyFilesTable"

import { Button } from "@/components/common/Button"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { useCompanyFilesContext } from "@/screens/Companies/edit/components/info/context/CompanyFilesContext"
import useFileTableSorting from "@/screens/Companies/edit/components/info/hooks/useFileTableSorting"

const CompanyFilesSection: FC<{
  fileList: SignedUrl[]
  openFileUploadDialog?: () => void
}> = ({ fileList, openFileUploadDialog }) => {
  const { isActiveCompany } = useCompanyFilesContext()

  const [isArchivedVisible, setIsArchivedVisible] = useState<boolean>(false)
  const handleToggleFilesVisibility = () => setIsArchivedVisible((prev) => !prev)
  const { data, sorting, handleSortingChange } = useFileTableSorting({
    fileList,
    isActiveCompany,
    isArchivedVisible,
  })

  return (
    <Box className='flex flex-col rounded-lg border border-gray-400 p-6'>
      <Typography variant='subtitle1' className='mb-6 text-ml text-gray-900'>
        Uploaded Files
      </Typography>
      <Box className={`mb-4 flex items-center ${isActiveCompany ? "justify-between" : "justify-end"} align-middle`}>
        {isActiveCompany && (
          <Button
            variant='primary'
            appearance='text'
            className='size-fit p-2'
            onClick={handleToggleFilesVisibility}
            startIcon={isArchivedVisible ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
          >
            {isArchivedVisible ? "Hide" : "Show"} Archived
          </Button>
        )}
        <Button
          size='medium'
          appearance='outlined'
          startIcon={<UploadFileOutlined fontSize='small' />}
          onClick={openFileUploadDialog}
        >
          Upload Additional Files
        </Button>
      </Box>
      <CompanyFilesTable data={data} sorting={sorting} handleSortingChange={handleSortingChange} />
    </Box>
  )
}

export default CompanyFilesSection
